import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import menu from './images/menu.png'
import cancel from './images/cancel.png'
import $ from 'jquery'

function Navbar() {
    const [curico, upcurico] = useState(menu);
    const[toggleProp1,uptoggleProp1]=useState("");
    const[toggleProp2,uptoggleProp2]=useState("");
    useEffect(() => {
        document.querySelector('#mn').addEventListener('click', () => {
            if (document.querySelector('#mn').checked === true) {
                upcurico(cancel);
            }
            else {
                upcurico(menu);
            }
        })//for big screen dark mode button
        document.querySelector('#nmode_').addEventListener('click', () => {
            if (document.querySelector('#night_mode').checked == false) {
                document.querySelector('body').classList.add('nightbackground');
                document.querySelector('#night_mode').checked = true;
                document.querySelector('.navbar').classList.replace('bg-light', 'bg-dark');
                document.querySelector('.navbar').classList.replace('navbar-light', 'navbar-dark');
                //hiding sun
                document.querySelector('#suncss').style.display="none";
            }
            else {
                document.querySelector('body').classList.remove('nightbackground');
                document.querySelector('#night_mode').checked = false;
                document.querySelector('.navbar').classList.replace('bg-dark', 'bg-light');
                document.querySelector('.navbar').classList.replace('navbar-dark', 'navbar-light');
                //showing sun
                document.querySelector('#suncss').style.display="block";
            }
        })//for small screen dark mode button
        document.querySelector('.switch').addEventListener('click', () => {
            if (document.querySelector('#night_mode').checked == false) {
                document.querySelector('body').classList.add('nightbackground');
                document.querySelector('#night_mode').checked = true;
                document.querySelector('.navbar').classList.replace('bg-light', 'bg-dark');
                document.querySelector('.navbar').classList.replace('navbar-light', 'navbar-dark');
                //hiding sun
                document.querySelector('#suncss').style.display="none";
            }
            else {
                document.querySelector('body').classList.remove('nightbackground');
                document.querySelector('#night_mode').checked = false;
                document.querySelector('.navbar').classList.replace('bg-dark', 'bg-light');
                document.querySelector('.navbar').classList.replace('navbar-dark', 'navbar-light');
                //showing sun
                document.querySelector('#suncss').style.display="block";
            }
        })

            
    }, [])
        
        
    useEffect(()=>{
        //when menubar of hamberger appear this code will push it back to top
        //jQuery code
            if ($(window).width() <= 990) {//if  screen is md means menu will appear
                uptoggleProp1("collapse");
                uptoggleProp2("#navbarNavAltMarkup");
                $('.nav-item').click(function(){
                    $('#mn').prop('checked',false);
                    upcurico(menu);
                })
            }
           else {
                uptoggleProp1("");
                uptoggleProp2("");
                $('.nav-item').click(function(){
                    $('#mn').prop('checked',true);
                    upcurico(cancel);
                })
           }
    })//this code will keep running
    return (
        <>
            {/*------navbar-----*/}
            <nav className="navbar navbar-expand-lg navbar-light bg-light position-sticky sticky-top">
                <a className="navbar-brand" href="#"><b>{'{ Portfolio : Abu Faishal }'}</b></a>
                <label id="tico" htmlFor="mn" className="navbar-toggler" style={{ outline: "none", border: "none" }} type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <input type="checkbox" id="mn" hidden />
                    <img className="menuico" src={curico} alt="menu" />
                </label>
                <div class="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
                    <div class="navbar-nav ">
                        <NavLink exact activeClassName="current_active" to="/" className="nav-item nav-link" data-toggle={toggleProp1} data-target={toggleProp2} >Home</NavLink>
                        <NavLink exact activeClassName="current_active" to="/components/About" className="nav-item nav-link" data-toggle={toggleProp1} data-target={toggleProp2}>About</NavLink>
                        <NavLink exact activeClassName="current_active" to="/components/Skills" className="nav-item nav-link" data-toggle={toggleProp1} data-target={toggleProp2}>Skills</NavLink>
                        <NavLink exact activeClassName="current_active" to="/components/Works" className="nav-item nav-link" data-toggle={toggleProp1} data-target={toggleProp2}>Works</NavLink>
                        <NavLink exact activeClassName="current_active" to="/components/ContactForm" className="nav-item nav-link" data-toggle={toggleProp1} data-target={toggleProp2}>Contact</NavLink>
                    </div>
                    <i ></i>
                    <i className="fas fa-moon mx-2 " title="Night Mode" id="nmode_" style={{ fontSize: "24px", cursor: "pointer" }}></i>
                    <label htmlFor="" className="text-muted" id="nmode" >Night Mode :</label>
                    <label className="switch  nav-item" data-toggle={toggleProp1} data-target={toggleProp2}>
                        <input type="checkbox" id="night_mode" />
                        <span className="slider round"></span>
                    </label>
                </div>
            </nav>
            {/*------navbar-end-----*/}
        </>
    )
}

export default Navbar
